/**
 * PaymentSuccessPage
 *
 * With Razorpay, payment is confirmed inline on CartPage and the user is
 * navigated directly to /orders. This page now acts as a clean fallback
 * redirect in case someone lands on /payment/success directly.
 */
import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Spinner } from '../components/shared/index';

export default function PaymentSuccessPage() {
  const navigate = useNavigate();

  // Auto-redirect to orders after 3 seconds
  useEffect(() => {
    const t = setTimeout(() => navigate('/orders'), 3000);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div className="container section fade-in" style={{ maxWidth: 520, margin: '0 auto', textAlign: 'center' }}>
      <div style={{ background: 'white', border: '1px solid var(--border)', padding: '48px 40px', marginTop: 40 }}>
        <div style={{ fontSize: 64, marginBottom: 20 }}>✅</div>
        <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 36, fontStyle: 'italic', marginBottom: 12 }}>
          Payment Successful!
        </h2>
        <p style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.8, marginBottom: 28 }}>
          Your order has been placed. Redirecting you to your orders...
        </p>
        <Spinner size="sm" centered />
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginTop: 28 }}>
          <Link to="/orders" className="btn btn-gold btn-lg">View My Orders →</Link>
          <Link to="/browse" className="btn btn-outline">Continue Shopping</Link>
        </div>
      </div>
    </div>
  );
}